import React from "react";
import { FieldErrors, UseFormSetValue } from "react-hook-form";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { type CreateGamificationFormData } from "../../validations/gamification.validation";

interface RegulationsCardProps {
  setValue: UseFormSetValue<CreateGamificationFormData>;
  errors: FieldErrors<CreateGamificationFormData>;
}

export const RegulationsCard: React.FC<RegulationsCardProps> = ({
  setValue,
  errors,
}) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const file = e.target.files?.[0];
    setValue("regulations", file, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle>Regulamento</CardTitle>
      </CardHeader>
      <CardContent>
        <div>
          <Label htmlFor="regulations">Arquivo do Regulamento (PDF)</Label>
          <Input
            id="regulations"
            type="file"
            accept=".pdf"
            onChange={handleFileChange}
          />
          {errors.regulations && (
            <p className="text-sm text-red-500 mt-1">
              {errors.regulations.message}
            </p>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
